<template>
  <div class="row">
    <!-- Header -->
    <div class="col-12 mb-4">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div>
          <button @click="back" class="btn btn-sm btn-outline-secondary mb-2">
            <i class="mdi mdi-arrow-left mr-1"></i>{{ $t('common.back') }}
          </button>
          <h2 class="text-white font-weight-bold mb-1">{{ $t('superadmin.editPackage') }}</h2>
          <p class="text-muted small mb-0">{{ $t('superadmin.packagesSubtitle') }}</p>
        </div>
      </div>
    </div>

    <div class="col-12 grid-margin">
      <div class="card border-0 shadow-sm" style="background: #191c24; border-radius: 12px;">
        <div class="card-body p-4">
          <form class="forms-sample" @submit.prevent="submitForm">
            <div class="row mb-3">
              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="package_name">
                  {{ $t('superadmin.packageName') }} <span class="text-danger">*</span>
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-dark border-secondary text-muted"><i class="mdi mdi-cube-outline"></i></span>
                  </div>
                  <input
                    id="package_name"
                    type="text"
                    class="form-control bg-dark text-white border-secondary"
                    v-model="packageStore.package_name"
                    required
                  />
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="price">
                  {{ $t('superadmin.pricePerSeatMonth') }} (IDR) <span class="text-danger">*</span>
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-dark border-secondary text-muted">Rp</span>
                  </div>
                  <input
                    id="price"
                    type="number"
                    class="form-control bg-dark text-white border-secondary"
                    v-model.number="packageStore.price_per_person_per_month"
                    min="0"
                    required
                  />
                </div>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="limit_user">
                  {{ $t('superadmin.maxUserSeats') }} <span class="text-danger">*</span>
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-dark border-secondary text-muted"><i class="mdi mdi-account-multiple"></i></span>
                  </div>
                  <input
                    id="limit_user"
                    type="number"
                    class="form-control bg-dark text-white border-secondary"
                    v-model.number="packageStore.limit_user"
                    min="1"
                    required
                  />
                </div>
              </div>

              <div class="col-12 mb-3">
                <label class="text-light small font-weight-bold" for="description">
                  {{ $t('superadmin.packageDescription') }}
                </label>
                <textarea
                  id="description"
                  class="form-control bg-dark text-white border-secondary"
                  v-model="packageStore.description"
                  rows="4"
                ></textarea>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="d-flex justify-content-end align-items-center pt-3 border-top border-secondary">
              <button
                type="button"
                @click="back"
                class="btn btn-outline-secondary px-4 py-2 mr-3"
                :disabled="loading"
              >
                {{ $t('common.cancel') }}
              </button>
              <button
                type="submit"
                class="btn btn-warning px-5 py-2 font-weight-bold text-dark"
                :disabled="loading"
              >
                <span v-if="loading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
                <i v-else class="mdi mdi-check-circle-outline mr-1"></i>
                {{ loading ? $t('common.saving') : $t('common.update') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updatePackage, getPackageDetail } from '@/services/packageService';
import Swal from 'sweetalert2';

export default {
  name: 'EditPackageView',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    packageStore: {
      package_name: '',
      price_per_person_per_month: '',
      description: '',
      limit_user: 0,
    },
    loading: false,
  }),
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const resp = await getPackageDetail(this.id);
        const data = resp.data || resp;
        this.packageStore.package_name = data.package_name || '';
        this.packageStore.price_per_person_per_month = data.price_per_person_per_month || '';
        this.packageStore.description = data.description || '';
        this.packageStore.limit_user = data.limit_user || 0;
      } catch (err) {
        console.error('Error fetching package:', err);
      }
    },
    async submitForm() {
      this.loading = true;
      try {
        await updatePackage(this.id, this.packageStore);

        Swal.fire({
          icon: 'success',
          title: this.$t('common.success'),
          text: this.$currentLocale === 'id' ? 'Paket langganan berhasil diperbarui.' : 'Subscription plan updated successfully.',
          confirmButtonColor: '#ffab00',
        });

        this.$router.push({ name: 'DetailPackage', params: { id: String(this.id) } });
      } catch (err) {
        Swal.fire({
          icon: 'error',
          title: this.$t('common.error'),
          text: err.response?.data?.message || err.message || (this.$currentLocale === 'id' ? 'Gagal memperbarui paket' : 'Failed to update package'),
          confirmButtonColor: '#ffab00',
        });
      } finally {
        this.loading = false;
      }
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>